import type {
  CheckoutSessionResponse,
  CreateCreditPackCheckoutRequest,
  CreditBalanceResponse,
  CreditPackConfirmation,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const creditsApi = {
  async getBalance(businessId: string): Promise<CreditBalanceResponse> {
    const res = await api.api.credits[':businessId'].$get({
      param: { businessId },
    })
    return unwrap<CreditBalanceResponse>(res)
  },

  async createPackCheckout(
    request: CreateCreditPackCheckoutRequest,
  ): Promise<CheckoutSessionResponse> {
    const res = await api.api.subscription['credit-pack'].checkout.$post({ json: request })
    return unwrap<CheckoutSessionResponse>(res)
  },

  async confirmPack(businessId: string, sessionId: string): Promise<CreditPackConfirmation> {
    const res = await api.api.subscription['credit-pack'].confirm.$post({
      json: { businessId, sessionId },
    })
    return unwrap<CreditPackConfirmation>(res)
  },
}
